module.exports = "https://www.gc-qa.gnp.com.mx/d85bd614c3ed7348b1940d31a9b5333d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Stepper3@2x.svg
// module id = 1794
// module chunks = 0